import React, { useCallback, useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { ApiParams } from '../../../common/api/api';
import { useDebounce } from '../../../common/Debounce.hooks';
// import { useIdSearchableFilterOptions } from '../../../common/entityId.hooks';
// import { WorkflowEntity } from '../../workflow/Workflow.interface';
import { useFindApprovedFiles } from '../Document.hook';
import { ApprovedFileVersion } from '../Document.interface';

export interface DocumentAutoCompleteProps {
  className?: string;
  disabled?: boolean;
  value?: { id?: number; version?: number; url?: string };
  onChange?: (document?: ApprovedFileVersion) => void;
}

const DocumentAutoComplete: React.FC<DocumentAutoCompleteProps> = (
  props: DocumentAutoCompleteProps
) => {
  const { value, className, disabled, onChange } = props;
  const [search, setSearch] = useState<string>('');
  const [selected, setSelected] = useState<ApprovedFileVersion | undefined>();
  // const filterOptions = useIdSearchableFilterOptions<ApprovedFileVersion>(
  //   WorkflowEntity.File,
  //   'name'
  // );
  const [{ data }, get] = useFindApprovedFiles();
  const debouncedSearch: string = useDebounce(search, 300);
  const { id: fileId, version: fileVersion, url: storageKey } = value || {};

  const compare = useCallback(
    (item: ApprovedFileVersion) => {
      return (
        item.id === fileId &&
        item.version === fileVersion &&
        item.storageKey === storageKey
      );
    },
    [fileId, fileVersion, storageKey]
  );

  useEffect(() => {
    const params: ApiParams = {};
    if (debouncedSearch) {
      params.search = debouncedSearch;
    }
    get(params);
  }, [get, debouncedSearch]);

  useEffect(() => {
    // if no selected file yet
    if (selected) {
      return;
    }
    const selectedFile: ApprovedFileVersion | undefined = data?.find(compare);
    if (selectedFile) {
      setSelected(selectedFile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, compare]);

  useEffect(() => {
    if (selected && !compare(selected)) {
      setSelected(undefined);
    }
  }, [selected, compare]);

  return (
    <Autocomplete
      className={className}
      disabled={disabled}
      options={data ?? []}
      value={selected || null}
      getOptionLabel={file => `${file.key}: ${file.name} (v${file.version})`}
      // filterOptions={filterOptions}
      onInputChange={(_, value) => setSearch(value)}
      onChange={(_, value) => onChange?.(value || undefined)}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          variant='outlined'
          label='Search Approved Documents'
          InputProps={{ ...params.InputProps }}
        />
      )}
    />
  );
};

export default DocumentAutoComplete;
